module.exports = __webpack_public_path__ + "static/media/hug.39442791.jpg";